import Slider, { SliderProps } from './Slider';

export default Slider;
export type { SliderProps };
